<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>

<script>
import { mapState, mapActions } from 'vuex'
import api from '@/api'
import Cookie from 'js-cookie'

let activeCategories
try {
  activeCategories = JSON.parse(Cookie.get('cookie_config'))
} catch (e) {
  activeCategories = [ 1 ]
}

export default {
  name: 'CookieOverlay',
  data() {
    return {
      isOpen: true,
      details: false,
      categories: Array,
      checkboxes: Array,
      items: Array,
    }
  },
  computed: {
    ...mapState('auth', { activeUser: 'status', settings: 'settings' }),
    ...mapState('pages', [ 'legal_pages' ]),
    opened: {
      set() {
        this.isOpen = false
      },
      get() {
        return this.isOpen
      },
    },
    privacy_url() {
      return this.legal_pages.privacy ? this.$router.resolve({ name: 'page', params: { id: this.legal_pages.privacy.page_id } }).href : ''
    },
  },
  mounted() {
    this.getLegalPages()
    this.categories = this.settings.cookie_config ? this.settings.cookie_config.cookie_types || [] : []
    this.checkboxes = Cookie.get('track_all') === 'true' ? this.categories : activeCategories
    this.items = this.settings.cookie_config ? this.settings.cookie_config.items || [] : []
  },
  methods: {
    ...mapActions('pages', [ 'getLegalPages' ]),
    setCookies(all) {
      Cookie.set('cdisc', true, { expires: 365 })
      let checkboxes = this.checkboxes.filter(checkbox => this.categories.includes(checkbox))
      if (all) {
        Cookie.set('track_all', true, { expires: 365 })
        checkboxes = this.categories
      } else {
        Cookie.remove('track_all')
      }
      if (checkboxes.length) {
        Cookie.set('cookie_config', checkboxes, { expires: 365 })
      } else {
        Cookie.remove('cookie_config')
      }
      api.items.getItems(
        'settings.consent',
        { cdisc: true, track_all: all, categories: checkboxes.length ? checkboxes.join('-') : undefined },
      ).finally(() => {
        const loc = location || window.location
        loc.replace(loc.origin + loc.pathname + loc.search)
      })
    },
  },
}
</script>
